const en = {
  common: {
    close: "Close",
    loadMore: "Load more",
    shownCount: "Showing {{count}} records",
    error: "Error",
    warning: "Warning",
    success: "Success",
    cancel: "Cancel",
    delete: "Delete",
    save: "Save",
    edit: "Edit",
    create: "Create",
    ok: "OK",
    loading: "Loading...",
    retry: "Try Again",
    back: "Back",
    share: "Share",
    download: "Download",
    rename: "Rename",
    remove: "Remove",
    na: "N/A",
    user: "User",
    signInRequired: "Sign In Required",
    guestRestricted: "Please sign in to access this feature.",
    info: "Info",
    refresh: "Refresh"
  },
  auth: {
    login: {
      title: "Future Document",
      subtitle: "Enterprise Cloud File Management Software",
      email: "Email",
      emailPlaceholder: "example@email.com",
      password: "Password",
      passwordPlaceholder: "••••••••",
      forgotPassword: "Forgot Password",
      signIn: "Sign In",
      noAccount: "Don't have an account? ",
      signUp: "Sign Up",
      licenseLookup: "License Lookup",
      loginFailed: "Login Failed",
      emailRequired: "Email Required",
      emailRequiredMsg: "Please enter your email address to reset password.",
      emailSent: "Email Sent",
      emailSentMsg: "Password reset link has been sent. (Demo)",
      orContinueWith: "or continue with",
      guestLogin: "Continue as Guest",
      guestLoginSubtext: "Browse home page without signing in"
    },
    register: {
      title: "Create Account",
      subtitle: "Welcome to Future Document",
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      email: "Email",
      emailPlaceholder: "example@email.com",
      password: "Password",
      passwordPlaceholder: "••••••••",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "••••••••",
      licenseCode: "License Code",
      licenseCodePlaceholder: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      acceptTerms: "I accept the ",
      termsOfService: "Terms of Service",
      and: " and ",
      privacyPolicy: "Privacy Policy",
      signUp: "Sign Up",
      hasAccount: "Already have an account? ",
      signIn: "Sign In",
      veryWeak: "Very Weak",
      weak: "Weak",
      medium: "Medium",
      strong: "Strong",
      veryStrong: "Very Strong",
      fullNameRequired: "Full name is required",
      fullNameMin: "Full name must be at least 2 characters",
      emailRequired: "Email address is required",
      emailInvalid: "Please enter a valid email address",
      passwordRequired: "Password is required",
      passwordMin: "Password must be at least 6 characters",
      confirmPasswordRequired: "Please confirm your password",
      passwordsNoMatch: "Passwords do not match",
      licenseRequired: "License code is required",
      licenseInvalid: "License code format is invalid (expected 25 characters)",
      licenseVerifyFailed: "License code could not be verified. Please check your code and try again.",
      licenseAlreadyActivated: "This license code has already been activated.",
      licenseRegionTitle: "Warning",
      licenseNotForTurkey: "These license codes cannot be used in Turkey.",
      mustBeSignedIn: "You must be signed in to activate a license.",
      mustAcceptTerms: "You must accept the terms and conditions.",
      registerError: "An error occurred while verifying your license. Please try again."
    },
    support: {
      title: "Support Request",
      subtitle: "Your license code was not found. Please fill in the form below to contact our support team.",
      searchedLicense: "Searched License: ",
      fullName: "Full Name *",
      fullNamePlaceholder: "Enter your full name",
      email: "Email Address *",
      emailPlaceholder: "example@company.com",
      companyName: "Company Name (Optional)",
      companyNamePlaceholder: "Enter your company name",
      message: "Your Message *",
      messagePlaceholder: "Describe the issue with your license code...",
      submit: "Submit Request",
      backToLogin: "Back to Login",
      fillRequired: "Please fill in all required fields.",
      sendError: "An error occurred while sending the support request. Please try again.",
      requestReceived: "Request Received!",
      requestReceivedMsg: "Your support request has been successfully created. We will respond to your email address as soon as possible."
    },
    licenseLookup: {
      title: "License Lookup",
      subtitle: "Enter your 25-character license code to view your license information",
      licenseCode: "License Code",
      format: "Format: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      placeholder: "XXXXX",
      lookup: "Lookup License",
      notFoundTitle: "License Not Found",
      notFoundMsg: "The license code you entered was not found in our system. You can create a support request for assistance.",
      createSupport: "Create Support Request",
      purchaseLicense: "Purchase New License",
      enterComplete: "Please enter a complete license code",
      lookupError: "An error occurred while looking up your license. Please try again."
    },
    licenseInfo: {
      title: "License Information",
      subtitle: "Details about your license",
      noData: "No License Data",
      noDataDesc: "Please look up a license first.",
      licenseCode: "License Code",
      type: "License Type",
      maxUsers: "Max Users",
      activatedBy: "Activated By",
      expiresAt: "Expires At",
      activated: "Activated",
      available: "Available",
      activateNow: "Activate Now"
    },
    errors: {
      emailInUse: "This email address is already in use.",
      invalidEmail: "Invalid email address.",
      operationNotAllowed: "This operation is currently not available.",
      weakPassword: "Password must be at least 6 characters.",
      userDisabled: "This account has been disabled.",
      userNotFound: "No user found with this email address.",
      wrongPassword: "Incorrect password.",
      invalidCredential: "Invalid login credentials.",
      tooManyRequests: "Too many failed attempts. Please try again later.",
      networkError: "Network connection error. Please check your internet connection.",
      generic: "An error occurred. Please try again.",
      notSignedIn: "Not signed in"
    }
  },
  home: {
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    defaultUser: "FutureDoc",
    folders: "Folders",
    files: "Files",
    gbUsage: "GB Usage",
    quickActions: "Quick Actions",
    upload: "Upload",
    foldersAction: "Folders",
    aiAssistant: "AI Assistant",
    notifications: "Notifications",
    recentFiles: "Recent Files",
    seeAll: "See All",
    noFilesYet: "No files uploaded yet",
    uploadFirstFile: "Upload First File",
    cloudStorage: "Cloud Storage",
    storageUsed: "{{used}} GB / {{total}} GB used",
    minAgo: "{{count}} min ago",
    hoursAgo: "{{count}} hours ago",
    daysAgo: "{{count}} days ago"
  },
  ai: {
    chat: {
      title: "Document Assistant",
      systemMessage: "Hello! I am your document assistant. I can answer your questions based on the files you have uploaded.",
      welcomeMsg: "Hello! I can help you search your documents, answer questions about their content, and provide insights. What would you like to know?",
      tempResponse: "This feature is awaiting API integration. Please try again later.",
      guardrails: "Responses are based solely on your uploaded documents",
      typing: "Scanning documents...",
      placeholder: "Ask a question about your documents...",
      sources: "Sources:",
      page: "Page {{num}}",
      citationTitle: "Source Document",
      citationInfo: "Source: {{fileName}}\nPage: {{page}}",
      citationOpenError: "Could not open the source document."
    },
    ocr: {
      title: "OCR Result",
      fileNotFound: "File not found",
      confidenceScore: "Confidence Score",
      classification: "Classification",
      unidentified: "Unidentified",
      approvalRequired: "Approval Required (HITL)",
      approvalMsg: "OCR confidence is below 80%. Please review the text and approve.",
      tags: "Tags",
      extractedText: "Extracted Text",
      characters: "{{count}} characters",
      noOcrText: "No OCR text found.",
      piiTitle: "Sensitive Data Detected (PII/DLP)",
      piiMsg: "National ID, IBAN, or similar sensitive data has been detected in this document.",
      approveBtn: "Approve OCR Result",
      highConfidence: "High Confidence",
      mediumConfidence: "Medium Confidence",
      lowConfidence: "Low Confidence",
      veryLowConfidence: "Very Low Confidence",
      loadError: "Failed to load file.",
      approved: "Approved",
      approvedMsg: "OCR result has been approved and the file is now ready.",
      approvalFailed: "Approval process failed."
    }
  },
  search: {
    title: "Search",
    subtitle: "Search file contents, names, tags, and AI classifications",
    placeholder: "Search files, tags, or content...",
    pendingApproval: "Pending Approval",
    processing: "Processing",
    scanning: "Scanning",
    quarantined: "Quarantined",
    tipsTitle: "Search Tips",
    tipFileName: "Search by file name",
    tipTags: "Search by tags",
    tipOcr: "Search within OCR text",
    tipAi: "Search by AI classification",
    noResults: "No results found",
    tryDifferent: "Try different keywords or adjust filters",
    advancedFilters: "Advanced Filters",
    recentSearches: "Recent Searches",
    clearRecent: "Clear",
    popularTags: "Popular Tags",
    noTagsAvailable: "No tags available",
    resultCount: "{{count}} results found ({{total}} total files)",
    sortBy: "Sort",
    sortOptions: { relevance: "Relevance", date: "Date", name: "Name", size: "Size" },
    page: "Page",
    matchTypes: { name: "Name", tag: "Tag", content: "Content", classification: "Class" },
    columns: { name: "Name", match: "Match", score: "Score", size: "Size", status: "Status", tags: "Tags", date: "Date" },
    filters: {
      title: "Filter Results",
      fileType: "File Type",
      status: "Status",
      folder: "Folder",
      allFolders: "All Folders",
      dateRange: "Date Range",
      dateFrom: "From",
      dateTo: "To",
      sizeRange: "File Size",
      sizeMin: "Min (bytes)",
      sizeMax: "Max (bytes)",
      sizeHint: "Size in bytes (e.g. 1048576 = 1 MB)",
      tags: "Tags",
      clearAll: "Clear All",
      apply: "Apply",
      types: { all: "All Types", pdf: "PDF", doc: "Documents", image: "Images", spreadsheet: "Spreadsheets", presentation: "Presentations", other: "Other" },
      statuses: { all: "All Status", READY: "Ready", PROCESSING: "Processing", NEED_APPROVAL: "Needs Approval", QUARANTINED: "Quarantined" }
    }
  },
  files: {
    move: {
      action: "Move",
      title: "Move \"{{name}}\"",
      destination: "Destination folder",
      root: "Top level (no folder)",
      confirm: "Move",
      done: "Moved.",
      failed: "Move failed.",
      errorSelf: "A folder cannot be moved into itself.",
      errorChild: "A folder cannot be moved into one of its subfolders.",
      errorDepth: "This would exceed the folder depth limit (10 levels).",
      errorMissing: "The item or destination folder no longer exists.",
      newSubfolderIn: "New folder in \"{{name}}\""
    },
    title: "My Files",
    noFilesYet: "No files yet",
    detail: {
      title: "File Detail",
      fileNotFound: "File not found.",
      details: "Details",
      created: "Created",
      modified: "Modified",
      size: "Size",
      type: "Type",
      folder: "Folder",
      file: "File",
      loadError: "Failed to load file information.",
      preview: "Preview",
      tapToPreview: "Tap to preview",
      noDownloadUrl: "Download URL not available.",
      demoDownload: "Downloads are disabled in demo mode.",
      demoDelete: "Deleting is disabled in demo mode.",
      saveFile: "Save File",
      downloadComplete: "File downloaded to: {{path}}",
      downloadError: "Failed to download file.",
      deleteTitle: "Delete File",
      deleteMsg: "\"{{name}}\" will be moved to the trash. You can restore it within 30 days.",
      deleteSuccess: "File deleted successfully.",
      deleteError: "Failed to delete file.",
      ocrAvailable: "OCR Text Available",
      ocrDesc: "View extracted text and AI suggestions",
      versionHistory: "Version History",
      versions: "Versions",
      noVersions: "No saved versions yet.",
      viewAllVersions: "View all",
      versionHistoryDesc: "View and restore previous versions"
    },
    preview: {
      title: "File Preview",
      loading: "Loading file...",
      loadError: "Failed to load file.",
      noUrl: "File URL not available.",
      unsupportedType: "This file type is not supported for preview.",
      unsupportedTitle: "Preview Unavailable",
      fileNotFound: "File not found."
    },
    status: {
      scanning: "Scanning",
      processing: "Processing",
      need_approval: "Needs Approval",
      quarantined: "Quarantined",
      ready: "Ready"
    },
    upload: {
      quotaWarning: "You have used over 80% of your quota: storage {{storage}}%, operations {{ops}}%.",
      quotaBlockedStorage: "Your storage quota is full; these files cannot be uploaded. Free up space or upgrade your plan.",
      quotaBlockedOps: "Your monthly operation quota is used up; uploads are blocked.",
      title: "Upload File",
      tapToSelect: "Click or drag files here",
      formats: "PDF, DOCX, XLSX, PPTX, JPG, PNG, TIFF",
      maxSize: "Max. 5 GB",
      tags: "Tags (separate with commas)",
      tagsPlaceholder: "invoice, 2026, important",
      targetFolder: "Target folder",
      rootFolder: "Root (no folder)",
      selectedFiles: "Selected Files ({{count}})",
      notProcessable: "Not processable (>500MB)",
      uploadBtn: "Upload {{count}} Files",
      sizeError: "Size Error",
      sizeErrorMsg: "{{name}} exceeds the 5 GB limit.",
      selectWarning: "Please select at least one file.",
      uploadComplete: "Upload Complete",
      uploadSuccessMsg: "{{success}} files uploaded successfully!",
      uploadPartialMsg: "{{success}} files uploaded, {{fail}} files failed."
    },
    versions: {
      title: "Version History",
      loadError: "Failed to load version history.",
      versionNum: "Version {{num}}",
      current: "Current",
      today: "Today",
      yesterday: "Yesterday",
      daysAgo: "{{count}} days ago",
      restore: "Restore",
      restoreTitle: "Restore Version",
      restoreMsg: "Are you sure you want to restore version {{version}}?",
      restoreSuccess: "Version restored successfully.",
      restoreConfirm: "This will replace the current version. A backup of the current version will be saved automatically.",
      restoreNote: "Change note",
      demoRestore: "Version restore is disabled in demo mode.",
      demoDownload: "Version download is disabled in demo mode.",
      noVersions: "No Version History",
      noVersionsDesc: "Version history will appear here as you make changes.",
      compareVersions: "Compare Versions",
      selectSecond: "Select one more version to compare.",
      readyToCompare: "Two versions selected — click Compare Versions.",
      clearSelection: "Clear selection",
      changeNote: "Change Note",
      changeNotePlaceholder: "Describe what changed in this version…",
      changeNoteRequired: "A change note is required when uploading a new version.",
      sizeChange: "Size Change",
      totalVersions: "Total Versions",
      latestSize: "Latest Size",
      totalSize: "Total Size",
      fileSize: "File Size",
      preview: "Preview",
      download: "Download",
      previewUnavailable: "Preview not available for this file type.",
      uploadNew: "Upload New Version",
      selectFile: "Select File",
      upload: "Upload",
      uploadSuccess: "New version uploaded successfully.",
      uploadError: "Failed to upload new version.",
      demoUpload: "Version upload is disabled in demo mode.",
      older: "Older",
      newer: "Newer"
    },
    share: {
      byRole: "Share by role",
      byRoleHint: "Everyone in your company with the selected roles can access the file. The same roles in other companies cannot.",
      saveRoles: "Save role sharing",
      rolesSaved: "File shared with {{count}} role(s).",
      rolesCleared: "Role sharing removed.",
      rolesFailed: "Could not save role sharing.",
      rolesNoCompany: "Role-based sharing requires your account to belong to a company.",
      sharedWithMyRole: "Shared with my role",
      title: "Share File",
      newShare: "New Share",
      emailAddress: "Email Address",
      emailPlaceholder: "user@company.com",
      permissionLevel: "Permission Level",
      timeLimit: "Time Limit (days, optional)",
      timeLimitPlaceholder: "No limit",
      shareBtn: "Share",
      sharedWith: "Shared With ({{count}})",
      notSharedYet: "Not shared with anyone yet",
      view: "View",
      editPerm: "Edit",
      downloadPerm: "Download",
      loadError: "Failed to load data.",
      emailEmpty: "Please enter an email address.",
      emailInvalid: "Please enter a valid email address.",
      shareSuccess: "File shared with {{email}}.",
      shareFailed: "Sharing failed.",
      revokeTitle: "Revoke Share",
      revokeMsg: "Access for {{email}} will be removed.",
      revokeFailed: "Revoke operation failed."
    },
    trash: {
      title: "Trash",
      retention: "Deleted items are permanently removed after {{count}} days.",
      empty: "Trash is empty",
      name: "Name",
      deletedAt: "Deleted at",
      purgeIn: "Deleted permanently in",
      days: "{{count}} days",
      folder: "Folder",
      restore: "Restore",
      deleteForever: "Delete permanently",
      emptyTrash: "Empty trash",
      emptyConfirm: "All items in the trash will be permanently deleted. This cannot be undone.",
      deleteForeverConfirm: "\"{{name}}\" will be permanently deleted. This cannot be undone.",
      loadError: "Could not load the trash.",
      actionError: "The action could not be completed. Please try again."
    },
    folders: {
      title: "Folders",
      fileCount: "{{count}} files",
      noFoldersYet: "No folders yet",
      noFoldersMsg: "Create a new folder to organize your files.",
      newFolder: "New Folder",
      folderName: "Folder name",
      newName: "New name",
      deleteFolder: "Delete Folder",
      deleteFolderMsg: "The folder \"{{name}}\" and its files will be moved to the trash; subfolders move up one level. You can restore it within 30 days.",
      folderCreated: "Folder created!",
      loadError: "Failed to load folders.",
      createError: "Failed to create folder.",
      renameError: "Failed to rename folder.",
      deleteError: "Failed to delete folder.",
      nameEmpty: "Folder name cannot be empty."
    }
  },
  settings: {
    title: "Settings",
    account: "Account",
    application: "Application",
    supportSection: "Support",
    profile: "Profile",
    profileDesc: "Manage your account information",
    notifications: "Notifications",
    notificationsDesc: "Notification preferences",
    security: "Security",
    securityDesc: "2FA and security settings",
    workspace: "Workspace",
    workspaceDesc: "Switch between workspaces",
    storage: "Storage",
    storageDesc: "Quota and usage information",
    appearance: "Appearance",
    appearanceDesc: "Theme and display preferences",
    language: "Language",
    languageDesc: "App language selection",
    adminPanel: "Admin Panel",
    adminPanelDesc: "Company info, team users, quota and audit logs",
    helpSupport: "Help & Support",
    helpSupportDesc: "FAQ and support requests",
    helpSupportMsg: "For support, you can email support@futuredocument.com.",
    privacyPolicy: "Privacy Policy",
    privacyPolicyDesc: "Data privacy policies",
    termsOfService: "Terms of Service",
    termsOfServiceDesc: "Service terms and conditions",
    kvkk: "KVKK Notice",
    kvkkDesc: "Personal data clarification text",
    distanceSales: "Distance Sales Agreement",
    distanceSalesDesc: "Remote sales contract for digital services",
    deliveryConditions: "Delivery & Service Conditions",
    deliveryConditionsDesc: "Activation, support and service delivery",
    cancellationReturn: "Cancellation & Refund",
    cancellationReturnDesc: "Cancel, return and withdrawal terms",
    about: "About",
    aboutDesc: "App version information",
    aboutMsg: "Version 1.0.0\n© 2026 Future Tech Works Software Company",
    signOut: "Sign Out",
    signOutConfirm: "Are you sure you want to sign out?",
    comingSoon: "Access is restricted in demo mode.",
    version: "FutureDoc v1.0.0"
  },
  profile: {
    title: "Profile",
    profileInfo: "Profile Information",
    name: "Name",
    namePlaceholder: "Your name",
    email: "Email",
    userId: "User ID",
    emailVerified: "Email Verified",
    emailNotVerified: "Email Not Verified",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    updatePassword: "Update Password",
    deleteAccount: "Delete Account",
    deleteAccountMsg: "This action cannot be undone. All your data will be deleted.",
    deleteMyAccount: "Delete My Account",
    nameEmpty: "Name cannot be empty.",
    profileUpdated: "Your profile has been updated.",
    profileUpdateError: "Failed to update profile.",
    fillAllFields: "Please fill in all fields.",
    passwordMinLength: "New password must be at least 6 characters.",
    passwordsNoMatch: "Passwords do not match.",
    passwordUpdated: "Your password has been updated.",
    wrongPassword: "Current password is incorrect.",
    passwordChangeError: "Failed to change password.",
    accountDeleted: "Account Deleted",
    accountDeletedMsg: "Your account and all data have been deleted.",
    deleteError: "Failed to delete account."
  },
  admin: {
    deactivateUser: "Deactivate",
    activateUser: "Activate",
    inactiveBadge: "INACTIVE",
    confirmDeactivate: "Deactivate {{email}}? The user is signed out immediately and cannot sign in again.",
    userDeactivated: "{{email}} has been deactivated.",
    userActivated: "{{email}} is active again.",
    userStatusFailed: "Could not change the user status.",
    title: "Admin Panel",
    orgPanelTitle: "Admin Panel",
    orgPanelSubtitle: "Manage your company and team accounts",
    orgPanelSubtitleCompany: "Managing {{name}}",
    platformPanelSubtitle: "Platform-wide user, role and license management",
    companyTab: "Company",
    teamTab: "My Team",
    soldCompaniesTab: "Sold Companies",
    soldCompaniesHelp: "Companies with the Company role that purchased a license under your Admin account. View their license link and downstream dealers/users.",
    drpackLicensesTitle: "All Licenses",
    drpackLicensesHelp: "Read-only copy from Firebase licenses. Source licenses table is never modified.",
    syncDrpackLicenses: "Sync from licenses",
    drpackSynced: "{{count}} licenses synced to AdminLicenses.",
    drpackSyncError: "Failed to sync licenses.",
    drpackLoadError: "Failed to load licenses.",
    drpackSyncedCount: "Synced licenses",
    drpackCountriesCount: "Countries",
    drpackCompaniesCount: "Using companies",
    drpackUsedCount: "Used licenses",
    drpackActivatedCount: "Activated",
    drpackAvailableCount: "Available",
    searchDrpackLicenses: "Search by country, using company, code…",
    noDrpackLicenses: "No licenses in AdminLicenses yet.",
    noDrpackLicensesHint: "Click “Sync from licenses” to copy records from licenses into AdminLicenses.",
    groupByCountry: "By assigned country",
    groupByUsingCompany: "By using company",
    drpackUnknownCountry: "Unknown country",
    drpackUnassignedCompany: "Unassigned company",
    drpackLicenseUnit: "licenses",
    drpackAssignedCountry: "Assigned country",
    drpackUsingCompany: "Using company",
    drpackSoldTo: "Sold to (seller)",
    drpackValidUntil: "Valid until",
    drpackUsed: "Used",
    drpackUnused: "Unused",
    drpackType: "Type",
    drpackStatus: "Status",
    drpackMaxUsers: "Max users",
    drpackActivated: "Activated",
    drpackAvailable: "Available",
    drpackLicenseDetail: "License detail",
    drpackActivatedBy: "Activated by",
    drpackSource: "Source",
    drpackRawFields: "License fields",
    soldCompaniesTotal: "Sold companies",
    soldCompaniesWithLicense: "With license code",
    soldCompaniesNetwork: "Network accounts",
    searchSoldCompanies: "Search companies",
    searchSoldCompaniesPlaceholder: "Name, email, license, country…",
    noSoldCompanies: "No sold companies yet",
    noSoldCompaniesDesc: "Create a Company-role account for overseas license buyers you sold to.",
    addCompanyAccount: "Add Company",
    addCompanyHelp: "Create a Company-role account for an overseas buyer (e.g. Erbil Plastic). Fill trade name and optional company details.",
    viewCompany: "View",
    editSoldCompany: "Edit company",
    soldCompanyDetail: "Company detail",
    soldCompanyInfoHelp: "Edit this sold company’s name and profile. Trade name is required; other fields are optional.",
    soldCompanyInfoRequired: "Trade name is required for company accounts.",
    soldCompanyUpdated: "Company information updated.",
    licenseCode: "License code",
    licenseLinkedViaRole: "Linked via Company role",
    networkSize: "Network",
    companyNetwork: "Accounts under this company",
    companyNetworkEmpty: "No dealers, users or viewers under this company yet.",
    orgCompanyIntro: "Update your licensed company profile. This is required for Admin accounts.",
    orgUsersHelp: "You can manage Company, Dealer, User and Viewer accounts under your organization.",
    addTeamUser: "Add Team User",
    saveCompany: "Save Company Info",
    companySaved: "Company information saved.",
    companySaveError: "Failed to save company information.",
    cannotEditPeerAdmin: "You cannot edit other Admin accounts.",
    myLicensesTab: "My Licenses",
    myLicensesIntro: "Licenses assigned to your company, with product, seller and validity details.",
    myLicensesTotal: "Total licenses",
    myLicensesValid: "Valid licenses",
    myLicenseProduct: "Product",
    myLicenseValid: "Valid",
    myLicenseExpired: "Expired",
    searchMyLicenses: "Search by code, product, seller, date…",
    noMyLicenses: "No licenses found.",
    quotaTab: "Quota & Usage",
    auditTab: "Audit Logs",
    lookupLogsTab: "License Lookups",
    lookupLogsLoadError: "Could not load license lookup logs. Check Full Admin Firestore permissions.",
    lookupLogsIntro: "Every public and portal check is stored as its own row — including repeats of the same license. Visible only to Full Admin.",
    lookupRepeatCount: "{{count}} queries",
    lookupTotalSummary: "{{total}} queries · {{unique}} distinct licenses",
    lookupLogsSearch: "Search by key, IP, city, country or ISP…",
    noLookupLogs: "No license lookups yet",
    lookupColTime: "Time",
    lookupColKey: "License key",
    lookupColStatus: "Status",
    lookupColIp: "IP",
    lookupColLocation: "City / Country",
    lookupColIsp: "ISP",
    lookupColDevice: "Device / PC",
    lookupColSource: "Source",
    lookupRefresh: "Refresh",
    lookupSourcePublic: "Public site",
    lookupSourcePortal: "Portal",
    lookupSourceMobile: "Mobile app",
    lookupDetailUa: "User agent",
    lookupDetailLang: "Language",
    lookupDetailTz: "Timezone",
    lookupDetailCoords: "Coordinates",
    lookupDetailPage: "Page",
    lookupDetailReferrer: "Referrer",
    lookupStatus_valid: "Valid",
    lookupStatus_expired: "Expired",
    lookupStatus_revoked: "Revoked",
    lookupStatus_pending: "Pending",
    lookupStatus_not_found: "Not found",
    lookupStatus_invalid_format: "Invalid format",
    lookupStatus_error: "Error",
    lookupStatus_unknown: "Unknown",
    loginLogsTab: "Login Logs",
    loginLogsLoadError: "Could not load login logs. Check Full Admin Firestore permissions.",
    loginLogsIntro: "Every successful sign-in from the web panel, iOS, and Android is stored in Firebase with time, IP, and device details. Visible only to Full Admin.",
    loginLogsSearch: "Search by email, IP, city, country, ISP or device…",
    noLoginLogs: "No login records yet",
    loginColUser: "User",
    loginTotalSummary: "{{total}} logins",
    loginSourceWeb: "Web panel",
    loginSourceIos: "iOS",
    loginSourceAndroid: "Android",
    loginDetailDevice: "Device name",
    loginDetailOs: "Operating system",
    usersTab: "Users & Roles",
    rolesTab: "Role Permissions",
    monthlyQuota: "Monthly Operation Quota",
    used: "used",
    quotaWarning: " ⚠️ Approaching quota limit!",
    burstCapacity: "Burst capacity: {{count}} operations",
    storageUsage: "Storage Usage",
    concurrentUsers: "Concurrent Users",
    active: "Active",
    limit: "Limit",
    licenseInfo: "1 License = 20 Concurrent Users",
    aiTokenUsage: "AI Token Usage",
    tokens: "{{count}} tokens",
    tokenDesc: "This month's AI processing consumption",
    noAuditLogs: "No audit logs yet",
    searchUsers: "Search users",
    searchUsersPlaceholder: "Email, name or role…",
    usersHierarchyHelp: "Hierarchy: Full Admin → Admin (bulk license) → Company (overseas) → Dealer → User → Viewer. Assign parent to link accounts.",
    user: "User",
    role: "Role",
    parent: "Parent account",
    noParent: "No parent",
    parentHelp: "Parent defines the organizational tree (e.g. Dealer under Company).",
    actions: "Actions",
    noUsers: "No users found.",
    editRole: "Edit role",
    addUser: "Add User",
    addUserHelp: "Create Admin, Company, Dealer, User or Viewer accounts. Admin and Company can include company details. Full Admin cannot be created here.",
    createUser: "Create User",
    addDisplayName: "Full name",
    addDisplayNamePlaceholder: "e.g. Acme Company Admin",
    addEmail: "Email",
    addPassword: "Password",
    addConfirmPassword: "Confirm password",
    addNameRequired: "Full name is required (min 2 characters).",
    addEmailRequired: "Email is required.",
    addEmailInvalid: "Email format is invalid.",
    addEmailInUse: "This email is already registered.",
    addEmailReserved: "This email is reserved for the platform Full Admin.",
    addPasswordMin: "Password must be at least 6 characters.",
    addPasswordsNoMatch: "Passwords do not match.",
    userCreated: "User {{email}} created as {{role}}.",
    userCreateError: "Failed to create user.",
    companyInfoTitle: "Company Information",
    companyInfoHelp: "Required for Admin role. Registers this account as a licensed company (different from the Company role).",
    companyInfoRequired: "Company information is required for Admin role.",
    companyTradeName: "Trade name",
    companyTradeNamePlaceholder: "Legal / commercial company name",
    companyTaxId: "Tax ID / VAT No",
    companyTaxIdPlaceholder: "e.g. 1234567890",
    companyAddress: "Address",
    companyAddressPlaceholder: "Full business address",
    companyPhone: "Phone",
    companyEmail: "Company email",
    companyWebsite: "Website",
    companyDiscountRate: "Discount rate (%)",
    companyCountry: "Country",
    companyCountryPlaceholder: "e.g. Turkey",
    companyCity: "City",
    companyCityPlaceholder: "e.g. Istanbul",
    companyRegion: "Region / State",
    companyRegionPlaceholder: "e.g. Marmara",
    companySectors: "Service sector categories",
    companySectorsHelp: "Select one or more sectors (e.g. Packaging, Food).",
    sector_packaging: "Packaging",
    sector_food: "Food",
    sector_electronics: "Electronics",
    sector_textile: "Textile",
    sector_automotive: "Automotive",
    sector_chemicals: "Chemicals",
    sector_construction: "Construction",
    sector_pharma: "Pharma",
    sector_logistics: "Logistics",
    sector_retail: "Retail",
    sector_agriculture: "Agriculture",
    sector_other: "Other",
    errCompanyTradeName: "Trade name is required.",
    errCompanyTaxId: "Tax ID is required.",
    errCompanyAddress: "Address is required.",
    errCompanyPhone: "Phone is required.",
    errCompanyEmail: "Valid company email is required.",
    errCompanyCountry: "Country is required.",
    errCompanyCity: "City is required.",
    errCompanyRegion: "Region is required.",
    errCompanySectors: "Select at least one sector category.",
    errCompanyDiscount: "Discount rate must be between 0 and 100.",
    roleUpdated: "User role updated.",
    roleUpdateError: "Failed to update role.",
    usersLoadError: "Failed to load users.",
    cannotAssignRole: "You cannot assign this role.",
    cannotEditFullAdmin: "Only Full Admin can change Full Admin accounts.",
    fullAdminLocked: "Platform Full Admin email cannot be demoted.",
    rolesHelp: "Role permissions are stored in Firestore (roles collection). Sync writes the default permission matrix.",
    syncRolesFirebase: "Sync roles to Firebase",
    rolesSeeded: "{{count}} roles synced to Firebase.",
    rolesSeedError: "Failed to sync roles.",
    role_full_admin: "Full Admin",
    role_admin: "Admin",
    role_company: "Company",
    role_dealer: "Dealer",
    role_user: "User",
    role_viewer: "Viewer",
    role_auditor: "Auditor / Local accountant",
    roleDesc_full_admin: "Platform owner — full access including user & role management.",
    roleDesc_admin: "Bulk license buyer company — must provide company details; manage licenses and organization users.",
    roleDesc_company: "Overseas license buyer — manage dealers and company operations.",
    roleDesc_dealer: "Sub-dealer under a company — manage dealer users.",
    roleDesc_user: "Operational account under a dealer — read/write modules.",
    roleDesc_viewer: "View-only license account — no write actions.",
    roleDesc_auditor: "Read-only access to the company's invoices, accounts, statements and documents."
  },
  notif: {
    title: "Notifications",
    titleWithCount: "Notifications ({{count}})",
    markAllRead: "Mark All Read",
    justNow: "Just now",
    minAgo: "{{count}} min ago",
    hoursAgo: "{{count}} hours ago",
    daysAgo: "{{count}} days ago",
    empty: "No notifications",
    emptyDesc: "File shares, OCR results, and quota warnings will appear here."
  },
  licenseRenewal: {
    title: "License Renewal",
    intro: "Choose the licenses and quantities you want to renew. Your request is sent to your license provider for approval.",
    requestButton: "Request renewal",
    selectTitle: "Licenses to renew",
    sentTo: "Request will be sent to {{seller}}",
    noAdmin: "Your account is not linked to a license provider. Please contact support.",
    adminFallback: "License provider",
    noLicenses: "No licenses are assigned to your company.",
    currentCount: "{{count}} licenses",
    expiredCount: "{{count}} expired",
    selectedCount: "{{count}} selected",
    renewQuantity: "Quantity to renew",
    chooseLicenses: "Choose licenses",
    hideLicenses: "Hide licenses",
    selectAll: "Select all",
    selectExpired: "Select expired",
    clearSelection: "Clear",
    summaryTitle: "Request summary",
    totalQuantity: "Total quantity",
    noteLabel: "Note",
    notePlaceholder: "Renewal period, extra requirements…",
    submit: "Send renewal request",
    submitted: "Your renewal request for {{count}} licenses has been sent.",
    submitError: "The renewal request could not be sent. Please try again.",
    nothingSelected: "Enter a quantity for at least one product.",
    quantityBelowSelection: "Quantity for {{product}} cannot be lower than the number of selected licenses.",
    myRequests: "My renewal requests",
    noRequests: "You have not sent any renewal requests yet.",
    requestTitle: "License renewal request",
    requestQuantity: "{{count}} licenses",
    items: "Requested licenses",
    noSpecificLicenses: "No specific license codes selected.",
    notifyAdmin: "{{company}} requested renewal of {{count}} licenses."
  },
  support: {
    title: "Support Center",
    subtitle: "Track your requests and talk to the support team in one place.",
    newTicket: "New ticket",
    loadError: "Tickets could not be loaded. Please try again.",
    searchPlaceholder: "Search by subject, ticket no or person",
    backToList: "All tickets",
    justNow: "just now",
    you: "You",
    unread: "New reply",
    scope: {
      mine: "Opened by me",
      assigned: "Assigned to me",
      all: "All tickets",
      public: "Web form requests"
    },
    filter: {
      active: "Active",
      unread: "Unread",
      all: "All"
    },
    stats: {
      active: "Active tickets",
      unread: "New replies",
      waiting: "Waiting for reply",
      resolved: "Resolved"
    },
    status: {
      open: "Open",
      in_progress: "In progress",
      waiting_customer: "Waiting for customer",
      resolved: "Resolved",
      closed: "Closed"
    },
    priority: {
      P1: "P1 · Urgent",
      P2: "P2 · High",
      P3: "P3 · Normal",
      P4: "P4 · Low"
    },
    priorityHint: {
      P1: "Work has stopped completely. Use only for critical outages.",
      P2: "An important feature is blocked for you or your team.",
      P3: "Something is not working as expected but there is a workaround.",
      P4: "General question or minor issue; no impact on daily work."
    },
    sla: {
      P1: "within 2 hours",
      P2: "within 8 hours",
      P3: "within 1 business day",
      P4: "within 3 business days"
    },
    periodPriority: {
      month_end: "Month-end / declaration period: closing-sensitive tickets are raised one level.",
      provisional_tax: "Provisional-tax period: closing-sensitive tickets are raised one level.",
      raised: "Priority {{from}} → {{to}}."
    },
    mail: {
      ticket: "Ticket",
      priority: "Priority",
      category: "Category",
      requester: "Requested by",
      open: "Open"
    },
    category: {
      technical: "Technical issue",
      accounting: "Accounting and declarations",
      license: "License",
      billing: "Billing",
      account: "Account & access",
      feature: "Feature request",
      other: "Other"
    },
    categoryDesc: {
      technical: "Errors, crashes, sync or upload problems",
      accounting: "Ledger, invoices, closing and tax declarations",
      license: "Activation, renewal or license limits",
      billing: "Invoices, payments and pricing",
      account: "Login, password, users and roles",
      feature: "Ideas and improvement suggestions",
      other: "Anything else you need help with"
    },
    source: {
      web: "Web portal",
      ios: "iOS app",
      android: "Android app"
    },
    empty: {
      title: "No tickets yet",
      desc: "When you need help, open a ticket and follow the conversation here.",
      filteredTitle: "No tickets match",
      filteredDesc: "Try a different filter or search term.",
      clearFilters: "Clear filters"
    },
    public: {
      emptyTitle: "No web form requests",
      emptyDesc: "Requests sent from the login page support form will appear here.",
      intro: "Sent by visitors from the login page support form. Reply by e-mail and mark them as done.",
      reply: "Reply",
      replySubject: "Your FutureDocs support request",
      markDone: "Mark as done",
      reopen: "Reopen"
    },
    form: {
      title: "Open a support ticket",
      subtitle: "Tell us what happened; clear details help us solve it faster.",
      categoryStep: "What do you need help with?",
      categoryRequired: "Please choose a topic.",
      detailsStep: "Describe the issue",
      subject: "Subject",
      subjectPlaceholder: "e.g. Invoice PDF cannot be downloaded",
      subjectRequired: "Please enter a subject of at least 5 characters.",
      description: "Details",
      descriptionPlaceholder: "What were you trying to do, what happened instead, and since when?",
      descriptionRequired: "Please add at least {{count}} characters so we can understand the issue.",
      descriptionHint: "Include steps to reproduce, error messages and the page or screen you were on.",
      license: "Related license",
      optional: "optional",
      noLicense: "Not license related",
      priorityStep: "How urgent is it?",
      submit: "Submit ticket",
      submitError: "The ticket could not be created. Please try again.",
      routingTitle: "Who will answer?",
      routingProvider: "Your license provider's support team",
      routingPlatform: "FutureDocs platform support",
      routingDesc: "You will be notified of every reply and can continue the conversation from the web portal or the mobile app.",
      tipsTitle: "Tips for a fast answer",
      tip1: "One ticket per issue keeps the conversation focused.",
      tip2: "Write the exact error message and the steps that led to it.",
      tip3: "Mention the document, invoice or record number if relevant.",
      slaTitle: "Target first response"
    },
    quick: {
      looking: "Thanks for reaching out, we are looking into it.",
      needInfo: "Could you share a screenshot and the exact steps that lead to the problem?",
      fixed: "The issue has been fixed. Could you check and confirm on your side?"
    },
    detail: {
      sendError: "Your message could not be sent. Please try again.",
      statusError: "The status could not be updated.",
      copy: "Copy ticket number",
      openedAgo: "Opened {{time}}",
      createdTitle: "Ticket created.",
      createdDesc: "Your ticket number is {{no}}. We will notify you when there is a reply.",
      statusChanged: "{{name}} changed the status to",
      staffTag: "Support",
      sending: "Sending...",
      closedNote: "This ticket is closed. Reopen it if the issue is back.",
      replyReopens: "Write a reply; this will reopen the ticket",
      placeholder: "Write a message...",
      send: "Send",
      shortcut: "Ctrl / Cmd + Enter to send",
      status: "Status",
      resolvedPrompt: "Was your issue solved? Close the ticket, or reply to keep the conversation going.",
      requester: "Requester",
      handledBy: "Handled by",
      handledProvider: "License provider support",
      handledPlatform: "Platform support",
      channel: "Channel",
      created: "Created",
      lastActivity: "Last activity",
      notFound: "Ticket not found",
      notFoundDesc: "It may have been removed or you may not have access to it."
    },
    actions: {
      reopen: "Reopen",
      waitCustomer: "Wait for customer",
      resolve: "Mark resolved",
      markSolved: "My issue is solved",
      close: "Close ticket"
    }
  },
  nav: {
    trash: "Trash",
    home: "Home",
    files: "Files",
    search: "Search",
    settingsTab: "Settings",
    myFiles: "My Files",
    fileDetail: "File Detail",
    uploadFile: "Upload File",
    folderManagement: "Folder Management",
    shareFile: "Share File",
    filePreview: "File Preview",
    versionHistory: "Version History",
    profile: "Profile",
    notifications: "Notifications",
    adminPanel: "Admin Panel",
    licenseRenewal: "License Renewal",
    support: "Support",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    kvkk: "KVKK Notice",
    distanceSales: "Distance Sales Agreement",
    deliveryConditions: "Delivery & Service Conditions",
    cancellationReturn: "Cancellation & Refund",
    aiAssistant: "AI Assistant",
    ocrResult: "OCR Result"
  },
  workspace: {
    selectWorkspace: "Select Workspace",
    selectWorkspaceDesc: "Choose a workspace to continue",
    switched: "Workspace Switched",
    switchedTo: "You are now using {{name}}",
    loadError: "Failed to load workspaces",
    switchError: "Failed to switch workspace",
    roleOwner: "Owner",
    roleAdmin: "Admin",
    roleMember: "Member",
    roleViewer: "Viewer",
    joinWorkspace: "Join Workspace",
    joinWorkspaceDesc: "Enter an invitation code or contact your administrator",
    currentWorkspace: "Current Workspace",
    switchWorkspace: "Switch Workspace"
  },
  languages: {
    en: "English",
    ar: "العربية",
    selectLanguage: "Select Language"
  },
  network: {
    offline: "You are offline. Some features may be unavailable.",
    weak: "Weak internet connection detected.",
    restored: "Connection restored!",
    offlineMode: "Offline Mode",
    syncPending: "{{count}} changes pending sync"
  },
  security: {
    twoFactorAuth: "Two-Factor Authentication",
    sessionHistory: "Session History"
  },
  errorBoundary: {
    title: "An Unexpected Error Occurred",
    message: "The application encountered an unexpected error. Please try again.",
    retry: "Try Again"
  },
  legal: {
    lastUpdated: "Last updated: January 2026",
    privacyPolicy: {
      title: "Privacy Policy",
      section1Title: "1. Data Collection",
      section1: "Future Document collects only the data necessary to provide our cloud file management services. This includes your name, email address, and uploaded documents.",
      section2Title: "2. Data Storage",
      section2: "All data is stored securely on Firebase Cloud infrastructure with encryption at rest and in transit.",
      section3Title: "3. Data Usage",
      section3: "Your data is used solely for providing our services including document storage, OCR processing, and AI-assisted document analysis. We do not use your data for model training.",
      section4Title: "4. Data Sharing",
      section4: "We do not sell or share your personal data with third parties except as required by law or as necessary to provide our services.",
      section5Title: "5. Data Retention",
      section5: "Data is retained for the duration of your account. Upon account deletion, all data is permanently removed within 30 days.",
      section6Title: "6. User Rights",
      section6: "You have the right to access, correct, or delete your personal data at any time through your account settings.",
      section7Title: "7. Cookies & Analytics",
      section7: "We use essential cookies for authentication and session management. Analytics data is collected anonymously to improve our services.",
      section8Title: "8. Contact",
      section8: "For privacy-related inquiries, contact us at"
    },
    termsOfService: {
      title: "Terms of Service",
      section1Title: "1. Acceptance of Terms",
      section1: "By using Future Document, you agree to these Terms of Service and our Privacy Policy.",
      section2Title: "2. Service Description",
      section2: "Future Document provides enterprise cloud file management with OCR processing, AI-assisted document analysis, and secure file sharing capabilities.",
      section3Title: "3. License",
      section3: "A valid license code is required to register and use the service. Each license grants access for up to 20 concurrent users.",
      section4Title: "4. User Responsibilities",
      section4: "Users are responsible for maintaining the confidentiality of their account credentials and for all activities under their account.",
      section5Title: "5. Prohibited Uses",
      section5: "You may not use the service for any illegal purposes or to upload malicious content.",
      section6Title: "6. Service Availability",
      section6: "We strive for 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance will be announced in advance.",
      section7Title: "7. Intellectual Property",
      section7: "All content uploaded by users remains the property of the respective users. Future Document retains no ownership over user data.",
      section8Title: "8. Limitation of Liability",
      section8: "Future Tech Works shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.",
      section9Title: "9. Termination",
      section9: "We reserve the right to suspend or terminate accounts that violate these terms. Users may delete their account at any time."
    }
  },
  service: {
    quotaReached: "Your monthly operation quota has been reached.",
    quotaWarningTitle: "Quota Warning",
    quotaWarningMsg: "You have used 80% of your monthly operation quota ({{used}}/{{limit}})",
    fileSharedTitle: "File Shared",
    fileSharedMsg: "{{name}} shared a file with you"
  },
  accounting: {
    title: "Accounting",
    invoices: {
      title: "Invoices",
      totalInvoices: "Total Invoices",
      totalAmount: "Total Amount",
      paidAmount: "Paid Amount",
      pendingAmount: "Pending Amount",
      search: "Search invoices...",
      allStatuses: "All Statuses",
      allTypes: "All Types",
      newInvoice: "New Invoice",
      noInvoices: "No invoices yet",
      createFirst: "Create your first invoice",
      invoiceNo: "Invoice No",
      type: "Type",
      typeManual: "Manual",
      customer: "Customer",
      vendor: "Vendor",
      date: "Date",
      dueDate: "Due Date",
      issueDate: "Invoice date",
      paidDateLabel: "Paid Date",
      status: "Status",
      statusDraft: "Draft",
      statusPending: "Pending",
      statusApproved: "Approved",
      statusPaid: "Paid",
      statusCancelled: "Cancelled",
      lineItems: "Line Items",
      description: "Description",
      descriptionPlaceholder: "Product or service description",
      quantity: "Qty",
      unitPrice: "Unit Price",
      taxRateLabel: "Tax %",
      lineTotal: "Total",
      subtotal: "Subtotal",
      tax: "Tax",
      grandTotal: "Grand Total",
      addItem: "Add Item",
      summary: "Summary",
      quickInfo: "Quick Info",
      itemCount: "{{count}} item(s)",
      invoiceInfo: "Invoice Information",
      currency: "Currency",
      vendorPlaceholder: "Vendor / Supplier name",
      customerPlaceholder: "Customer / Company name",
      timeline: "Status Timeline",
      current: "Current",
      relatedFiles: "Related Files",
      noRelatedFiles: "No related files",
      actions: "Actions",
      overdue: "Overdue",
      overdueMsg: "This invoice has passed its due date.",
      notFound: "Invoice not found.",
      loadError: "Failed to load invoice.",
      deleteTitle: "Delete Invoice",
      deleteMsg: "Are you sure you want to delete invoice \"{{no}}\"?",
      demoDelete: "Deletion is disabled in demo mode.",
      demoSave: "Invoice saved in demo mode.",
      saveError: "Failed to save invoice.",
      invoiceNoRequired: "Invoice number is required.",
      partyRequired: "Please enter vendor or customer name.",
      itemsRequired: "All line items must have a description, quantity and unit price."
    },
    accounts: {
      title: "Current Accounts",
      totalAccounts: "Total Accounts",
      totalReceivable: "Total Receivable",
      totalPayable: "Total Payable",
      customersVendors: "Customers / Vendors",
      search: "Search accounts...",
      allTypes: "All Types",
      allBalances: "All Balances",
      balancePositive: "Receivable (positive)",
      balanceNegative: "Payable (negative)",
      balanceZero: "Balanced (zero)",
      newAccount: "New Account",
      noAccounts: "No accounts yet",
      createFirst: "Create your first account",
      name: "Name",
      type: "Type",
      typeCustomer: "Customer",
      typeVendor: "Vendor",
      taxId: "Tax ID",
      email: "Email",
      phone: "Phone",
      address: "Address",
      balance: "Balance",
      tags: "Tags",
      accountInfo: "Account Information",
      peppolId: "Peppol / e-invoice ID",
      currency: "Currency",
      creditLimit: "Credit limit",
      paymentTermDays: "Payment term (days)",
      daysValue: "{{count}} days",
      taxClass: "Tax class",
      creditExceeded: "Credit limit exceeded",
      taxClasses: { standard: "Standard", reduced: "Reduced", zero: "Zero-rated", exempt: "Exempt", reverse: "Reverse charge" },
      errors: { required: "Required", peppol: "Use scheme:id, e.g. 0088:5790000435951", nonNegative: "Must be zero or more", days: "Whole days between 0 and 365", enum: "Invalid value" },
      balanceSummary: "Balance Summary",
      receivable: "Receivable",
      payable: "Payable",
      balanced: "Balanced",
      totalDebit: "Total Debit",
      totalCredit: "Total Credit",
      transactionHistory: "Transaction History",
      noTransactions: "No transactions yet",
      newTransaction: "New Transaction",
      txType: "Transaction Type",
      txDate: "Date",
      txDescription: "Description",
      txDescriptionPlaceholder: "Payment, invoice, etc.",
      txDebit: "Debit",
      txCredit: "Credit",
      txAmount: "Amount",
      txInvoice: "Invoice",
      txInvoicePlaceholder: "Invoice ID (optional)",
      relatedContracts: "Related Contracts",
      noContracts: "No related contracts",
      paymentPlan: "Payment Plan",
      noPaymentPlan: "No payment plan",
      installment: "Installment",
      actions: "Actions",
      notFound: "Account not found.",
      loadError: "Failed to load account.",
      deleteTitle: "Delete Account",
      deleteMsg: "Are you sure you want to delete account \"{{name}}\"?",
      demoDelete: "Deletion is disabled in demo mode."
    },
    approvals: {
      title: "Approvals",
      pendingApprovals: "Pending Approvals",
      sentRequests: "Sent Requests",
      approvedCount: "Approved",
      rejectedCount: "Rejected",
      search: "Search approvals…",
      allStatuses: "All Statuses",
      newRequest: "New Request",
      tabPending: "My Pending Approvals",
      tabSent: "My Requests",
      noPending: "No pending approvals.",
      noSent: "You have not submitted any requests.",
      requestTitle: "Title",
      type: "Type",
      typeExpense: "Expense",
      typePayment: "Payment",
      typeInvoice: "Invoice",
      requestedBy: "Requested By",
      currentApprover: "Current Approver",
      amount: "Amount",
      currency: "Currency",
      date: "Date",
      status: "Status",
      statusPending: "Pending",
      statusInReview: "In Review",
      statusApproved: "Approved",
      statusRejected: "Rejected",
      requestInfo: "Request Details",
      description: "Description",
      descriptionPlaceholder: "Describe the reason for this request…",
      titlePlaceholder: "e.g. Office supplies purchase",
      titleRequired: "Title is required.",
      noApprover: "No approver found: your account is not linked to a parent account. Ask your administrator to link it.",
      selfApprovalForbidden: "You cannot approve or reject your own request.",
      amountRequired: "A valid amount is required.",
      relatedInvoice: "Related Invoice",
      invoicePlaceholder: "Invoice ID (optional)",
      thresholdInfo: "Approval Thresholds",
      tierManager: "Manager only",
      tierManagerDirector: "Manager + Director",
      tierManagerDirectorCFO: "Manager + Director + CFO",
      submit: "Submit for Approval",
      demoSubmit: "Request submitted (demo mode).",
      submitError: "Failed to submit request.",
      notFound: "Approval request not found.",
      loadError: "Failed to load request.",
      approvalChain: "Approval Chain",
      noChain: "No approval chain configured.",
      awaitingApproval: "Awaiting",
      chainProgress: "Progress",
      relatedResources: "Related Resources",
      noRelated: "No related resources.",
      actions: "Actions",
      approve: "Approve",
      reject: "Reject",
      approveTitle: "Approve Request",
      rejectTitle: "Reject Request",
      note: "Note",
      notePlaceholder: "Optional note for the requester…",
      approvedMsg: "Request approved successfully.",
      rejectedMsg: "Request has been rejected."
    }
  },
  inventory: {
    title: "Warehouse / Stock",
    totalProducts: "Total Products",
    criticalStockCount: "Critical Stock",
    totalStockValue: "Total Stock Value",
    categories: "Categories",
    searchPlaceholder: "Search by name, SKU, barcode…",
    allCategories: "All Categories",
    newProduct: "New Product",
    noProducts: "No products found.",
    criticalStock: "Critical",
    sku: "SKU",
    barcode: "Barcode",
    trade: { title: "Trade & logistics", barcodes: "Additional GTINs / barcodes", barcodesHelp: "Separate with commas. GTIN-8/12/13/14 check digits are verified.", gtins: "GTIN / barcodes", hsCode: "HS code", originCountry: "Country of origin (ISO)", dimensions: "Dimensions (L × W × H)", lengthCm: "Length (cm)", widthCm: "Width (cm)", heightCm: "Height (cm)", netWeightKg: "Net weight (kg)", grossWeightKg: "Gross weight (kg)", fixErrors: "Please correct the trade & logistics fields.", errors: { gtin: "Invalid GTIN check digit", tooLong: "Barcode is too long", hsCode: "HS code must be 6 to 12 digits", country: "Use a 2-letter ISO country code, e.g. TR", nonNegative: "Must be zero or more", grossBelowNet: "Gross weight cannot be below net weight", saveFailed: "Could not save the changes." } },
    partyCodes: { title: "Customer / supplier product codes", row: "Row {{n}}", empty: "No partner codes yet.", partyType: "Partner type", partyName: "Partner", code: "Partner's code", description: "Partner's description", customer: "Customer", supplier: "Supplier", linked: "Linked to an account card", add: "Add code", errors: { required: "Fill in the partner and the code", duplicate: "This code is already listed for the partner", saveFailed: "Could not save the codes." } },
    productName: "Product Name",
    category: "Category",
    currentStock: "Stock",
    costPrice: "Cost Price",
    salePrice: "Sale Price",
    updated: "Updated",
    unit: "Unit",
    description: "Description",
    descriptionPlaceholder: "Product description…",
    serialTracking: "Serial Tracking",
    lotTracking: "Lot Tracking",
    tags: "Tags",
    tagsPlaceholder: "e.g. imported, fragile",
    currency: "Currency",
    images: "Images",
    uploadImages: "Upload Images",
    chooseFiles: "Choose files…",
    productInfo: "Product Information",
    stockLevel: "Stock Level",
    current: "Current",
    technicalDocs: "Technical Documents",
    noDocs: "No technical documents.",
    certificates: "Certificates",
    noCertificates: "No certificates.",
    stockMovements: "Stock Movements",
    noMovements: "No stock movements recorded.",
    movementType: "Type",
    quantity: "Quantity",
    previousStock: "Previous",
    newStockLevel: "New Level",
    note: "Note",
    notePlaceholder: "Reason for stock change…",
    date: "Date",
    stockIn: "Stock In",
    stockOut: "Stock Out",
    stockInTitle: "Stock In",
    stockOutTitle: "Stock Out",
    stockInSuccess: "Stock entry recorded.",
    stockOutSuccess: "Stock exit recorded.",
    currentStockLabel: "Current stock",
    insufficientStock: "Quantity exceeds current stock!",
    actions: "Actions",
    deleteTitle: "Delete Product",
    deleteMsg: "Are you sure you want to delete \"{{name}}\"?",
    demoDelete: "Deletion is disabled in demo mode.",
    notFound: "Product not found.",
    loadError: "Failed to load product.",
    overview: "Overview",
    basicInfo: "Basic Information",
    pricingStock: "Pricing & Stock",
    minStockLevel: "Min Stock Level",
    maxStockLevel: "Max Stock Level",
    manualSKU: "Enter manually",
    autoSKU: "Auto-generate",
    nameRequired: "Product name is required.",
    skuRequired: "SKU is required.",
    documents: "Documents",
    technicalDocIds: "Technical Document IDs",
    docIdsPlaceholder: "doc-1, doc-2",
    docIdsHelp: "Comma separated file IDs.",
    certificateIds: "Certificate IDs",
    certIdsPlaceholder: "cert-1, cert-2",
    certIdsHelp: "Comma separated file IDs.",
    summary: "Summary",
    save: "Save",
    demoCreate: "Product created (demo mode).",
    createError: "Failed to create product.",
    namePlaceholder: "e.g. Dell PowerEdge R750",
    cat_electronics: "Electronics",
    cat_office: "Office Supplies",
    cat_furniture: "Furniture",
    cat_raw_material: "Raw Material",
    cat_packaging: "Packaging",
    cat_spare_parts: "Spare Parts",
    cat_consumables: "Consumables",
    cat_other: "Other"
  },
  movements: {
    title: "Inventory Movements",
    search: "Search movements...",
    allTypes: "All Types",
    allProducts: "All Products",
    newEntry: "New Movement",
    dateFrom: "From date",
    dateTo: "To date",
    clearFilters: "Clear Filters",
    noMovements: "No inventory movements found.",
    totalIn: "Total In",
    totalOut: "Total Out",
    transfers: "Transfers",
    adjustments: "Adjustments",
    date: "Date",
    product: "Product",
    type: "Type",
    type_in: "Stock In",
    type_out: "Stock Out",
    type_transfer: "Transfer",
    type_adjustment: "Adjustment",
    quantity: "Quantity",
    unitCost: "Unit Cost",
    reason: "Reason / Note",
    warehouse: "Warehouse",
    documentNo: "Document No",
    from: "From",
    to: "To",
    movementType: "Movement Type",
    productSelection: "Product & Quantity",
    productSearchPlaceholder: "Search by name, SKU or barcode...",
    productRequired: "Please select a product.",
    quantityRequired: "Quantity must be greater than 0.",
    warehouseRequired: "Source and destination warehouses are required for transfers.",
    currentStockLabel: "Current stock",
    lotNumber: "Lot Number",
    serialNumbers: "Serial Numbers",
    serialPlaceholder: "SN-001, SN-002, ...",
    serialHelp: "Comma separated serial numbers.",
    sourceWarehouse: "Source Warehouse",
    destWarehouse: "Destination Warehouse",
    warehousePlaceholder: "e.g. Main Warehouse",
    reasonPlaceholder: "Movement reason or note...",
    relatedInvoice: "Related Invoice ID",
    invoicePlaceholder: "inv-...",
    shipmentDocs: "Shipment Documents",
    addDoc: "Add New",
    noExistingDocs: "No shipment documents available.",
    newShipmentDoc: "New Shipment Document",
    chooseFile: "Choose file...",
    summary: "Summary",
    estimatedStock: "Estimated New Stock",
    totalCost: "Total Cost",
    save: "Save Movement",
    demoSuccess: "Movement recorded (demo mode).",
    submitError: "Failed to record movement."
  },
  shipments: {
    title: "Shipment Documents",
    search: "Search documents...",
    allTypes: "All Types",
    totalDocs: "Total Documents",
    waybills: "Waybills",
    packingLists: "Packing Lists",
    deliveryNotes: "Delivery Notes",
    noDocs: "No shipment documents found.",
    newDoc: "New Document",
    documentNo: "Document No",
    docType: "Document Type",
    type_waybill: "Waybill",
    type_packingList: "Packing List",
    type_deliveryNote: "Delivery Note",
    vendor: "Vendor / Carrier",
    vendorPlaceholder: "e.g. DHL, UPS...",
    date: "Date",
    relatedMovements: "Related Movements",
    movements: "movement(s)",
    file: "File",
    view: "View",
    noFile: "No file",
    created: "Created",
    create: "Create",
    docNoRequired: "Document number is required.",
    demoCreate: "Shipment document created (demo mode).",
    createError: "Failed to create document."
  },
  purchaseRequests: {
    title: "Purchase Requests",
    search: "Search requests...",
    allStatuses: "All Statuses",
    total: "Total Requests",
    pending: "Pending",
    ordered: "Ordered",
    received: "Received",
    noRequests: "No purchase requests found. Run a stock scan to detect critical items.",
    scanStock: "Scan Stock Levels",
    noAlerts: "All stock levels are healthy — no critical items detected.",
    scanResult: "{{count}} critical product(s) detected, {{created}} purchase request(s) created.",
    scanError: "Failed to scan stock levels.",
    product: "Product",
    currentStock: "Current Stock",
    minLevel: "Min Level",
    suggestedQty: "Suggested Qty",
    estCost: "Est. Cost",
    status: "Status",
    created: "Created",
    status_auto_generated: "Auto Generated",
    status_submitted: "Submitted",
    status_ordered: "Ordered",
    status_received: "Received",
    actionSubmit: "Submit",
    actionOrder: "Mark Ordered",
    actionReceive: "Receive",
    completed: "Completed",
    receiveTitle: "Receive Stock",
    newStock: "New Stock",
    receivedQty: "Received Quantity",
    receiveHelp: "Enter the actual received quantity. A stock-in movement will be created automatically.",
    confirmReceive: "Confirm Receive",
    receiveSuccess: "{{qty}} units of {{product}} received and stock updated.",
    receiveError: "Failed to receive stock."
  },
  criticalStock: {
    title: "Critical Stock",
    products: "product(s)",
    noCritical: "All stock levels OK",
    viewAll: "View Requests"
  },
  serialTracking: {
    title: "Serial Number Tracking",
    total: "Total Serials",
    inStock: "In Stock",
    sold: "Sold",
    warranty: "In Warranty",
    returned: "Returned",
    scrapped: "Scrapped",
    search: "Search serial no…",
    allStatuses: "All Statuses",
    status_in_stock: "In Stock",
    status_sold: "Sold",
    status_warranty: "In Warranty",
    status_returned: "Returned",
    status_scrapped: "Scrapped",
    serialNo: "Serial Number",
    status: "Status",
    purchaseDate: "Purchase Date",
    warrantyExpiry: "Warranty Expiry",
    customer: "Customer",
    history: "History",
    events: "event(s)",
    addSerial: "Add Serial",
    noSerials: "No serial numbers found.",
    serialRequired: "Serial number is required.",
    demoCreate: "Serial number created (demo mode).",
    createError: "Could not create serial number.",
    create: "Create",
    movementHistory: "Movement History",
    noHistory: "No history yet.",
    relatedFiles: "Related Files",
    warrantyExpired: "Expired",
    daysLeft: "days left",
    customerPlaceholder: "Customer name / company",
    tab: "Serial Numbers",
    viewAll: "View All Serials"
  },
  lotTracking: {
    title: "Lot / Batch Tracking",
    totalLots: "Total Lots",
    active: "Active",
    expiringSoon: "Expiring Soon",
    critical: "Critical",
    search: "Search lot no…",
    allStatuses: "All Statuses",
    status_active: "Active",
    status_expired: "Expired",
    status_recalled: "Recalled",
    lotNumber: "Lot Number",
    status: "Status",
    quantity: "Quantity",
    manufacturingDate: "Manufacturing Date",
    expiryDate: "Expiry Date",
    supplier: "Supplier",
    qualityCert: "Quality Cert.",
    viewCert: "View Certificate",
    addLot: "Add Lot",
    noLots: "No lots found.",
    lotRequired: "Lot number is required.",
    demoCreate: "Lot created (demo mode).",
    createError: "Could not create lot.",
    create: "Create",
    expired: "Expired",
    daysLeft: "days left",
    criticalAlert: "Critical",
    lotsExpiredOrCritical: "lot(s) expired or will expire in 7 days",
    warningAlert: "Warning",
    lotsExpiring30: "lot(s) will expire within 30 days",
    supplierPlaceholder: "Supplier name",
    qualityCertFileId: "Quality Cert. File ID",
    certIdPlaceholder: "File ID from documents",
    tab: "Lots",
    viewAll: "View All Lots"
  },
  session: {
    expiringTitle: "Your session is about to expire",
    expiringBody: "You will be signed out in {{seconds}} seconds due to inactivity.",
    stay: "Stay signed in",
    signOutNow: "Sign out",
    timedOut: "You were signed out after a period of inactivity. Please sign in again.",
    disabled: "Your account has been deactivated. Please contact your administrator.",
    sessionLimit: "The concurrent session limit has been reached. Sign out on another device and try again.",
    revoked: "Your session was ended from another location."
  },
  exchangeRates: {
    title: "Exchange Rates",
    subtitle: "Manual rate table against {{base}}; invoices use the rate of their rate date.",
    formTitle: "Add or update a rate",
    listTitle: "Rates",
    date: "Date",
    currency: "Currency",
    rateType: "Rate type",
    source: "Source",
    buy: "Buying",
    sell: "Selling",
    average: "Average",
    note: "Note",
    averageHint: "Leave the average empty to use the buy/sell midpoint. Saving the same date, currency and type replaces the rate.",
    allCurrencies: "All currencies",
    empty: "No rates entered yet",
    saved: "Rate saved.",
    loadError: "Rates could not be loaded.",
    saveError: "The rate could not be saved.",
    confirmDelete: "Delete the {{currency}} rate of {{date}}?",
    types: { forex: "Forex (döviz)", banknote: "Banknote (efektif)", custom: "Custom" },
    sides: { buy: "Buying", sell: "Selling", average: "Average" },
    errors: { date: "Enter a valid date", currency: "Choose a currency", sameAsBase: "Must differ from the base currency", enum: "Invalid value", source: "Enter a source (max 40 characters)", positive: "Must be greater than zero", sellBelowBuy: "Selling cannot be below buying", tooLong: "Too long" },
    invoice: { title: "Exchange rate", rateDate: "Rate date", side: "Rate used", found: "{{currency}}/{{base}} {{value}} ({{source}}, {{date}})", fallback: "No rate on {{requested}}; the latest earlier rate ({{date}}) is used.", missing: "No {{currency}} rate on or before {{date}}. Add it to the exchange-rate table first.", baseTotal: "Total in {{base}}" }
  },
  privacyRequests: {
    title: "Personal data requests (KVKK / GDPR)",
    subtitle: "Exercise your rights over your personal data; requests are answered within the legal deadline.",
    newTitle: "New request",
    type: "Request type",
    regime: "Applicable law",
    details: "Details",
    detailsPlaceholder: "Which data and what you would like us to do (e.g. the field to correct, the export format).",
    submit: "Submit request",
    submitted: "Request {{no}} received. It will be answered within {{days}} days.",
    submitError: "The request could not be submitted.",
    saveError: "The change could not be saved.",
    deadlineNote: "Legal deadline: {{days}} days from receipt (KVKK art. 13, GDPR art. 12). Under GDPR it may be extended once by {{extra}} days with a reason.",
    mineTitle: "My requests",
    emptyMine: "You have not filed any request.",
    queueTitle: "Request queue",
    emptyQueue: "No requests to handle.",
    openCount: "{{count}} open",
    overdueCount: "{{count}} overdue",
    no: "No.",
    statusLabel: "Status",
    received: "Received",
    deadline: "Deadline",
    requester: "Requester",
    withdraw: "Withdraw",
    confirmWithdraw: "Withdraw this request?",
    overdue: "Overdue ({{date}})",
    daysLeft: "{{count}} days left ({{date}})",
    daysLeft_one: "1 day left ({{date}})",
    types: {
      access: "Access",
      rectification: "Rectification",
      erasure: "Erasure",
      portability: "Portability"
    },
    typeDesc: {
      access: "Learn whether and how your data is processed and get a copy.",
      rectification: "Correct incomplete or inaccurate data.",
      erasure: "Delete or anonymise data that is no longer needed.",
      portability: "Receive your data in a machine-readable format."
    },
    regimes: {
      kvkk: "KVKK (Türkiye)",
      gdpr: "GDPR (EU / EEA)"
    },
    status: {
      received: "Received",
      in_review: "In review",
      completed: "Completed",
      rejected: "Rejected",
      withdrawn: "Withdrawn"
    },
    errors: {
      type: "Choose a request type.",
      tooShort: "Please describe the request (at least 10 characters).",
      tooLong: "Too long."
    },
    handle: {
      open: "Handle",
      note: "Response to the requester",
      noteHint: "Shown to the requester. A rejection must state its reason.",
      reasonRequired: "A rejection must state its reason.",
      extend: "Extend the deadline by {{days}} days (GDPR art. 12(3))",
      extensionReason: "Reason for the extension",
      extensionReasonRequired: "State the reason for the extension."
    }
  },
  auditLog: {
    title: "Audit Log",
    scopeAll: "Every record on the platform (user, action, entity, previous/new value).",
    scopeMine: "Records for you and the users you manage.",
    from: "From",
    to: "To",
    user: "User",
    allUsers: "All users",
    action: "Action",
    allActions: "All actions",
    entityType: "Entity type",
    entity: "Entity",
    apply: "Apply",
    search: "Search results…",
    count: "{{count}} records",
    exportCsv: "Download CSV",
    exportJsonl: "Download JSON Lines (SIEM)",
    exportCef: "Download CEF (SIEM)",
    exportMenu: "Export",
    emptyTitle: "No records found",
    emptyBody: "No audit records match the selected filters.",
    when: "When",
    previous: "Previous",
    next: "New",
    loadMore: "Load more",
    loadFailed: "Audit records could not be loaded."
  },
  cookies: {
    bannerText: "We use essential cookies for sign-in and security. With your permission we also collect anonymous usage statistics (Google Analytics) to improve the product.",
    policyLink: "Privacy policy",
    customize: "Preferences",
    necessaryOnly: "Essential only",
    acceptAll: "Accept all",
    settingsTitle: "Cookie preferences",
    necessaryTitle: "Essential cookies",
    necessaryDesc: "Required for sign-in, sessions, security and language preference; cannot be turned off.",
    analyticsTitle: "Analytics cookies",
    analyticsDesc: "Page views and usage statistics (Google Analytics / Firebase). Not loaded unless you allow it; you can withdraw at any time.",
    save: "Save",
    settingsLink: "Cookie preferences"
  },
  reauth: {
    title: "Confirm it's you",
    body: "This is a sensitive action, so please enter your password again. The confirmation is valid for a few minutes.",
    password: "Password",
    confirm: "Confirm",
    wrongPassword: "Incorrect password. Please try again."
  },
  sessions: {
    countHint: "Users active in the last 3 minutes ({{sessions}} sessions). Several devices of the same person count once.",
    revoke: "End",
    confirmRevoke: "End this session of {{user}}?",
    thisDevice: "This device",
    you: "You",
    policyTitle: "Session policy",
    idleMinutes: "Sign out after inactivity (minutes)",
    sessionLimit: "Concurrent user limit",
    rangeError: "Enter a whole number between {{min}} and {{max}}.",
    policyHint: "Applies to web and mobile for everyone in your company. The new timeout applies immediately; the user limit is checked at the next sign-in.",
    policyReadOnly: "Set by your company administrator.",
    policySaved: "Session policy saved.",
    policyError: "Could not save the session policy."
  },
  dataTransfer: {
    menu: "Import / export",
    exportXlsx: "Download as Excel (XLSX)",
    exportCsv: "Download as CSV",
    import: "Import from file…",
    importTitle: "Import {{entity}}",
    importHint: "Upload CSV or XLSX; the first row must be the column headers. Up to {{max}} rows. You'll see a preview first; nothing is saved without confirmation.",
    chooseFile: "Choose file",
    template: "template",
    downloadTemplate: "Download template",
    missingColumns: "Required columns not found: {{columns}}",
    tooManyRows: "The file has {{count}} rows; at most {{max}} can be imported at once.",
    summary: "{{valid}} rows ready, {{invalid}} rows with errors (rows with errors are skipped).",
    line: "Row {{line}}",
    moreErrors: "…and {{count}} more rows with errors",
    importCount: "Import {{count}} records",
    done: "{{created}} records created, {{failed}} failed.",
    fields: {
      sku: "SKU",
      name: "Name",
      barcode: "Barcode",
      category: "Category",
      unit: "Unit",
      currentStock: "Current stock",
      minStockLevel: "Min stock",
      maxStockLevel: "Max stock",
      costPrice: "Cost price",
      salePrice: "Sale price",
      currency: "Currency",
      status: "Status",
      description: "Description",
      type: "Type",
      taxId: "Tax ID",
      email: "Email",
      phone: "Phone",
      address: "Address",
      balance: "Balance",
      invoiceNo: "Invoice no",
      vendor: "Vendor",
      customer: "Customer",
      issueDate: "Issue date",
      dueDate: "Due date",
      amount: "Amount (excl. tax)",
      taxRate: "Tax rate (%)",
      totalAmount: "Total",
      date: "Date",
      productName: "Product name",
      quantity: "Quantity",
      unitCost: "Unit cost",
      reason: "Reason",
      lotNumber: "Lot no",
      peppolId: "Peppol ID",
      creditLimit: "Credit limit",
      paymentTermDays: "Payment term (days)",
      taxClass: "Tax class",
      barcodes: "Additional GTINs",
      hsCode: "HS code",
      originCountry: "Country of origin",
      lengthCm: "Length (cm)",
      widthCm: "Width (cm)",
      heightCm: "Height (cm)",
      netWeightKg: "Net weight (kg)",
      grossWeightKg: "Gross weight (kg)"
    },
    entities: {
      products: "Products",
      accounts: "Accounts",
      invoices: "Invoices",
      stockMovements: "Stock-movements"
    },
    rowErrors: {
      required: "{{field}} is required",
      number: "{{field}} must be a number",
      date: "{{field}} is not a valid date (DD.MM.YYYY or YYYY-MM-DD)",
      email: "{{field}} is not a valid email",
      enum: "{{field}} value is not recognised",
      duplicate: "{{field}} already exists",
      party: "A customer or vendor is required",
      positive: "{{field}} must be greater than zero",
      unknownProduct: "No product with this SKU",
      peppol: "{{field}} must look like 0088:5790000435951",
      nonNegative: "{{field}} cannot be negative",
      gtin: "{{field}} has an invalid GTIN check digit",
      hsCode: "{{field}} must be 6 to 12 digits",
      country: "{{field}} must be a 2-letter ISO code"
    },
    errors: {
      tooLarge: "The file exceeds the 5 MB limit.",
      unsupported: "Only .csv and .xlsx files are supported.",
      invalid: "The file could not be read. Check its format.",
      browser: "This browser can't read compressed XLSX; use CSV or update the browser.",
      exportFailed: "Export failed."
    }
  },
  scmUi: {
    openProductBom: "Open product / BOM",
    qualityInspections: "Quality inspections",
    packFinishedGoods: "Pack finished goods",
    consumeMaterials: "Consume materials",
    postOutput: "Post output",
    lots: "Lots",
    serials2: "Serials",
    addPallet: "Add to pallet",
    ship2: "Ship",
    close: "Close",
    receive: "Receive",
    deactivate: "Deactivate",
    confirm: "Confirm",
    createMo: "Create MO",
    centralReferenceCatalogsSupplyChainDocument: "Central reference catalogs for supply chain and document operations.",
    addItem: "Add item",
    foundationDirectoryUsersScmPlatformRoles: "Foundation directory of users and SCM/platform roles.",
    packBox: "Pack box",
    reverse: "Reverse",
    productRequired: "Product required",
    exportOrders: "Export Orders",
    exportOrdersCommercialDocuments: "Export orders and commercial documents",
    orders: "Orders",
    shipments: "Shipments",
    customs: "Customs",
    newExport: "New export",
    noExportOrders: "No export orders",
    code: "Code",
    customer: "Customer",
    destination: "Destination",
    incoterm: "Incoterm",
    total: "Total",
    status: "Status",
    open: "Open",
    exportDocuments: "Export documents",
    addDoc: "Add doc",
    noDocumentsYet: "No documents yet",
    type: "Type",
    no: "No",
    newExportOrder: "New export order",
    destinationCountry: "Destination country",
    currency: "Currency",
    forwarder: "Forwarder",
    product: "Product",
    select: "Select…",
    qty: "Qty",
    unitPrice: "Unit price",
    hsCode: "HS code",
    cancel: "Cancel",
    create: "Create",
    addExportDocument: "Add export document",
    documentNo: "Document no",
    autoEmpty: "Auto if empty",
    issue: "Issue",
    invalidTransition: "Invalid transition",
    manufacturingOrderNotFound: "Manufacturing order not found",
    execution: "Execution",
    workOrders: "Work orders",
    noWorkOrdersYet: "No work orders yet",
    releaseMoGenerateDefaultSteps: "Release the MO to generate default steps",
    name: "Name",
    start: "Start",
    done: "Done",
    extraStepName: "Extra step name",
    add: "Add",
    bomConsumption: "BOM / consumption",
    noBomLinesAddActiveBom: "No BOM lines. Add an active BOM on the product first.",
    component: "Component",
    per: "Per",
    required: "Required",
    consumed: "Consumed",
    productionOutput: "Production output",
    quantity: "Quantity",
    lotBatch: "Lot / batch",
    serialNumbers: "Serial numbers",
    commaNewlineSeparated: "Comma or newline separated",
    serials: "Serials:",
    internationalShipments: "International Shipments",
    oceanAirRoadExportMoves: "Ocean / air / road export moves",
    exportOrders2: "Export orders",
    containers: "Containers",
    newShipment: "New shipment",
    noShipments: "No shipments",
    export: "Export",
    route: "Route",
    mode: "Mode",
    container: "Container",
    newInternationalShipment: "New international shipment",
    exportOrder: "Export order",
    origin: "Origin",
    sea: "sea",
    air: "air",
    road: "road",
    rail: "rail",
    attachContainer: "Attach container",
    attach: "Attach",
    customerProductRequired: "Customer and product required",
    confirmOrderFirst: "Confirm the order first",
    delivered: "Delivered",
    salesOrders: "Sales Orders",
    customers: "Customers",
    fulfillment: "Fulfillment",
    newSo: "New SO",
    noSalesOrders: "No sales orders",
    warehouse: "Warehouse",
    reserved: "Reserved",
    picked: "Picked",
    packed: "Packed",
    price: "Price",
    newSalesOrder: "New sales order",
    ship: "Ship to",
    lastMileDelivery: "Last-mile delivery",
    carrier: "Carrier",
    trackingNo: "Tracking no",
    confirmDelivery: "Confirm delivery",
    titleRequired: "Title required",
    nonConformanceCapa: "Non-Conformance & CAPA",
    ncrLifecycleCorrectiveActions: "NCR lifecycle and corrective actions",
    inspections: "Inspections",
    newNcr: "New NCR",
    noNonConformances: "No non-conformances",
    title: "Title",
    severity: "Severity",
    source: "Source",
    correctiveActions: "Corrective actions",
    addCapa: "Add CAPA",
    noCapaYet: "No CAPA yet",
    action: "Action",
    owner: "Owner",
    description: "Description",
    newCorrectiveAction: "New corrective action",
    dueDate: "Due date",
    save: "Save",
    selectPalletFirst: "Select a pallet first",
    alreadyPallet: "Already on a pallet",
    packagesPallets: "Packages & Pallets",
    boxCartonPackingPalletBuild: "Box / carton packing and pallet build",
    packages: "Packages",
    newPackage: "New package",
    noPackages: "No packages",
    pallets: "Pallets",
    newPallet: "New pallet",
    noPallets: "No pallets",
    pkgs: "Pkgs",
    lot: "Lot",
    label: "Label",
    optionalLabel: "Optional label",
    warrantyRegistered: "Warranty registered",
    claimOpened: "Claim opened",
    warrantyExpired: "Warranty expired",
    serviceOrderCreated: "Service order created",
    warranty: "Warranty",
    registrationsClaims: "Registrations and claims",
    warranties: "Warranties",
    service: "Service",
    register: "Register",
    noWarranties: "No warranties",
    ends: "Ends",
    claims: "Claims",
    newClaim: "New claim",
    noClaims: "No claims",
    registerWarranty: "Register warranty",
    serial: "Serial",
    months: "Months",
    startDate: "Start date",
    newWarrantyClaim: "New warranty claim",
    openClaim: "Open claim",
    supplierProductRequired: "Supplier and product required",
    purchaseOrders: "Purchase Orders",
    poLifecycleStatusHistory: "PO lifecycle with status history",
    newPo: "New PO",
    noPurchaseOrders: "No purchase orders",
    supplier: "Supplier",
    details: "Details",
    newPurchaseOrder: "New purchase order",
    notes: "Notes",
    nameRequired: "Name is required",
    suppliers: "Suppliers",
    procurementSupplierMasterData: "Procurement supplier master data",
    search: "Search…",
    addSupplier: "Add supplier",
    noSuppliers: "No suppliers",
    addYourFirstSupplier: "Add your first supplier.",
    country: "Country",
    terms: "Terms",
    newSupplier: "New supplier",
    paymentTerms: "Payment terms",
    incoterms: "Incoterms",
    email: "Email",
    phone: "Phone",
    noData: "No data",
    count: "Count",
    scmReports: "SCM Reports",
    kpisPipelinesRecentAuditActivity: "KPIs, pipelines, recent audit activity",
    refresh: "Refresh",
    salesOrders2: "Sales orders",
    purchaseOrders2: "Purchase orders",
    manufacturing: "Manufacturing",
    pendingApprovals: "Pending approvals",
    returns: "Returns",
    openRmas: "Open RMAs",
    lowStockSkus: "Low stock SKUs",
    salesPipeline: "Sales pipeline",
    procurementPipeline: "Procurement pipeline",
    manufacturingPipeline: "Manufacturing pipeline",
    exportPipeline: "Export pipeline",
    recentAuditActivity: "Recent audit activity",
    noAuditEntries: "No audit entries",
    entity: "Entity",
    user: "User",
    generated: "Generated",
    selectProduct: "Select a product",
    invalidStatusTransition: "Invalid status transition",
    rfqs: "RFQs",
    requestQuotation: "Request for quotation",
    rfqList: "RFQ list",
    newRfq: "New RFQ",
    noRfqs: "No RFQs",
    items: "Items",
    history: "History",
    send: "Send",
    addQuote: "Add quote",
    createPo: "Create PO",
    supplierQuotation: "Supplier quotation",
    saveQuotation: "Save quotation",
    financeIntegration: "Finance Integration",
    createDraftInvoicesFromSalesPurchase: "Create draft invoices from sales / purchase orders",
    links: "Links",
    invoices: "Invoices",
    noFinanceLinksYet: "No finance links yet",
    invoice: "Invoice",
    amount: "Amount",
    noEligibleSalesOrders: "No eligible sales orders",
    linked: "linked",
    createInvoice: "Create invoice",
    noEligiblePurchaseOrders: "No eligible purchase orders",
    nameRequired2: "Name required",
    warehouses: "Warehouses",
    warehouseMasterLocations: "Warehouse master and locations",
    addWarehouse: "Add warehouse",
    noWarehouses: "No warehouses",
    location: "Location",
    default: "default",
    locations: "Locations",
    newWarehouse: "New warehouse",
    finishedGoods: "Finished Goods",
    rawMaterial: "Raw Material",
    overseas3pl: "Overseas / 3PL",
    qualityHold: "Quality Hold",
    city: "City",
    declarationsDutiesTaxesBrokers: "Declarations, duties, taxes, brokers",
    declarations: "Declarations",
    newDeclaration: "New declaration",
    noCustomsDeclarations: "No customs declarations",
    declaration: "Declaration",
    shipment: "Shipment",
    duties: "Duties",
    newCustomsDeclaration: "New customs declaration",
    declarationNo: "Declaration no",
    hsCodes: "HS codes",
    commaNewlineDefaultsFromExportLines: "Comma or newline; defaults from export lines",
    broker: "Broker",
    taxes: "Taxes",
    reservationsPicksPacksDispatchesDeliveries: "Reservations, picks, packs, dispatches, deliveries",
    reservations: "Reservations",
    pickLists: "Pick lists",
    packs: "Packs",
    dispatches: "Dispatches",
    deliveries: "Deliveries",
    customerMasterSalesOrders: "Customer master for sales orders",
    priceLists: "Price lists",
    noCustomers: "No customers",
    contact: "Contact",
    newCustomer: "New customer",
    billingAddress: "Billing address",
    defaultPriceList: "Default price list",
    notificationSent: "Notification sent",
    notificationEngine: "Notification Engine",
    myInbox: "My inbox",
    classicInbox: "Classic inbox",
    markAllRead: "Mark all read",
    noNotifications: "No notifications",
    message: "Message",
    unread: "unread",
    recentEngineEvents: "Recent engine events",
    noEventsLoggedYet: "No events logged yet",
    sendNotification: "Send notification",
    targetUserId: "Target user ID",
    defaultsYou: "Defaults to you",
    approvalSubmitted: "Approval submitted",
    approvalEngine: "Approval Engine",
    workflows: "Workflows",
    legacyApprovals: "Legacy approvals",
    submit: "Submit",
    noApprovalRequests: "No approval requests",
    requester: "Requester",
    approve: "Approve",
    reject: "Reject",
    submitApproval: "Submit approval",
    entityType: "Entity type",
    document: "Document",
    productionPlanning: "Production Planning",
    planFinishedGoodsQuantitiesThenRelease: "Plan finished-goods quantities, then release manufacturing orders",
    plans: "Plans",
    newPlan: "New plan",
    noProductionPlans: "No production plans",
    window: "Window",
    newProductionPlan: "New production plan",
    plannedQuantity: "Planned quantity",
    end: "End",
    rmWarehouse: "RM warehouse",
    fgWarehouse: "FG warehouse",
    customerRequired: "Customer required",
    serviceOrders: "Service Orders",
    repairServiceTicketsLinkedRmaWarranty: "Repair / service tickets linked to RMA or warranty",
    newService: "New service",
    noServiceOrders: "No service orders",
    assignee: "Assignee",
    newServiceOrder: "New service order",
    schedule: "Schedule",
    manufacturingOrders: "Manufacturing Orders",
    releaseExecuteConsumeMaterialsPostFinished: "Release, execute, consume materials, post finished goods",
    newMo: "New MO",
    noManufacturingOrders: "No manufacturing orders",
    planned: "Planned",
    completed: "Completed",
    noBom: "no BOM",
    newManufacturingOrder: "New manufacturing order",
    finishedProduct: "Finished product",
    activeBomSnapshottedCreate: "Active BOM is snapshotted on create",
    plannedQty: "Planned qty",
    inspectionSubmitted: "Inspection submitted",
    approved: "Approved",
    ncrCreated: "NCR created",
    recordApproveQualityInspections: "Record and approve quality inspections",
    newInspection: "New inspection",
    noInspectionsYet: "No inspections yet",
    plan: "Plan",
    result: "Result",
    openNcr: "Open NCR",
    qualityPlan: "Quality plan",
    manufacturingOrder: "Manufacturing order",
    containerLoadStatusShipmentLink: "Container load status and shipment link",
    newContainer: "New container",
    noContainers: "No containers",
    containerNo: "Container no",
    seal: "Seal",
    sealNo: "Seal no",
    overseasWarehouses: "Overseas Warehouses",
    overseas3plDistributionCenters: "Overseas / 3PL / distribution centers",
    overseas: "Overseas",
    allWarehouses: "All warehouses",
    noOverseasWarehouses: "No overseas warehouses",
    newOverseasWarehouse: "New overseas warehouse",
    selectPoWarehouse: "Select PO and warehouse",
    goodsReceiptPosted: "Goods receipt posted",
    goodsReceipt: "Goods Receipt",
    receiveAgainstPurchaseOrdersIntoWarehouse: "Receive against purchase orders into warehouse",
    goodsReceipts: "Goods receipts",
    newReceipt: "New receipt",
    noGoodsReceiptsYet: "No goods receipts yet",
    lines: "Lines",
    receiveFromPo: "Receive from PO",
    purchaseOrder: "Purchase order",
    ordered: "Ordered",
    alreadyRecv: "Already recv",
    receiveNow: "Receive now",
    postReceipt: "Post receipt",
    qualityPlans: "Quality Plans",
    inspectionChecklistsPerProduct: "Inspection checklists per product",
    noQualityPlans: "No quality plans",
    checks: "Checks",
    newQualityPlan: "New quality plan",
    anyGeneral: "Any / general",
    checklist: "Checklist",
    checkDescription: "Check description",
    returnCreated: "Return created",
    rmaOpened: "RMA opened",
    customerReturnsInspectRestockRefundScrap: "Customer returns, inspect, restock / refund / scrap",
    newReturn: "New return",
    noReturns: "No returns",
    reason: "Reason",
    openRma: "Open RMA",
    salesOrder: "Sales order",
    freightForwarders: "Freight Forwarders",
    carriersForwardersInternationalMoves: "Carriers / forwarders for international moves",
    forwarders: "Forwarders",
    noFreightForwarders: "No freight forwarders",
    newFreightForwarder: "New freight forwarder",
    priceLists2: "Price Lists",
    customerChannelPricing: "Customer / channel pricing",
    lists: "Lists",
    newList: "New list",
    noPriceLists: "No price lists",
    newPriceList: "New price list",
    product2: "Product…",
    issueRequired: "Issue required",
    returnMerchandiseAuthorization: "Return merchandise authorization",
    newRma: "New RMA",
    noRmas: "No RMAs",
    return: "Return",
    createService: "Create service",
    productName: "Product name",
    itemCreated: "Item created.",
    codeAlreadyExistsThisType: "Code already exists for this type.",
    masterData: "Master Data",
    referenceTypes: "Reference Types",
    searchCodeName: "Search code or name…",
    noItems: "No items",
    seedDefaultsAddNewReferenceItem: "Seed defaults or add a new reference item for this type.",
    active: "active",
    inactive: "inactive",
    draft: "draft",
    obsolete: "obsolete",
    variantName: "Variant name",
    eGSizeLColorBlue: "e.g. Size L / Color Blue",
    engineeringRev: "Engineering rev",
    specifications: "Specifications",
    materialDimensionsStandards: "Material, dimensions, standards…",
    userManagement: "User Management",
    adminPanel: "Admin Panel",
    youDoNotHavePermissionManage: "You do not have permission to manage users.",
    users: "Users",
    allRoles: "All roles",
    noUsers: "No users",
    noUsersMatchCurrentFilters: "No users match the current filters.",
    role: "Role",
    roleCatalog: "Role catalog",
    level: "level",
    signedAs: "Signed in as",
    moOutputReadyPackIntoBoxes: "MO output ready to pack into boxes / pallets",
    fgFromManufacturing: "FG from manufacturing",
    noFinishedGoodsYet: "No finished goods yet",
    completeProductionOutputManufacturingOrderFirst: "Complete production output on a manufacturing order first",
    warehouseNotFound: "Warehouse not found",
    addLocation: "Add location",
    aisle: "Aisle",
    rack: "Rack",
    bin: "Bin",
    noLocations: "No locations",
    printLocationLabels: "Location labels",
    aisleRackBin: "Aisle/Rack/Bin",
    supplierNotFound: "Supplier not found",
    profile: "Profile",
    edit: "Edit",
    productBothWarehousesAreRequired: "Product and both warehouses are required",
    sourceDestinationMustDiffer: "Source and destination must differ",
    transferPostedNetStockUnchanged: "Transfer posted (net stock unchanged)",
    stockTransfer: "Stock Transfer",
    moveQuantityBetweenWarehousesWithoutChanging: "Move quantity between warehouses without changing total stock",
    transfer: "Transfer",
    fromWarehouse: "From warehouse",
    warehouse2: "To warehouse",
    min: "Min",
    max: "Max",
    lot2: "Lot:",
    reversed: "reversed",
    linkedDocuments: "Linked documents",
    fileUser: "file, user…"
  }
};

export default en;
